import React from "react";

export const NumberCount = ({
  count,
  size = "default",
}: {
  count: number;
  size?: "default" | "sm";
}) => {
  return (
    <span
      className={`shrink-0 inline-flex items-center justify-center bg-accent-15 text-accent-regular rounded-full select-none cursor-default ${
        size === "sm" ? "px-1.5 py-px text-[10px]" : "px-1.5 py-px text-xs"
      }`}
    >
      {count}
    </span>
  );
};
